import React from 'react';
import { MapPin, Phone, Mail, Instagram, Clock } from 'lucide-react';
import FadeInSection from '../components/FadeInSection';
import PageBanner from '../components/PageBanner';
import { useCms } from '../context/CmsContext';

const Contact = () => {
  const { t, img } = useCms();
  const phoneDisplay = t('contact.phone', '+31 6 1234 5678');
  const phoneTel = phoneDisplay.replace(/\s/g, '');
  const email = t('contact.email', 'info@cocktailmannetje.nl');
  const werkgebied = t('contact.werkgebied', 'Heel Nederland');
  const bereik = t('contact.bereikbaarheid', 'Ma-Vr: 9:00 - 18:00 | Weekend: Op afspraak');
  const instagram = t('contact.instagram', 'https://www.instagram.com/cocktailmannetje1/');

  return (
    <div>
      <PageBanner
        image={img('banner.contact')}
        title={t('contact.hero_title', 'Contact')}
        subtitle={t('contact.hero_subtitle', 'Neem contact op voor vragen, boekingen of een vrijblijvende offerte')}
      />

      {/* Contact Info */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <FadeInSection>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Details */}
          <div className="space-y-8">
            <div>
              <h2 className="font-serif-display text-4xl mb-6 text-[#13498f]">Contactgegevens</h2>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="bg-[#13498f] p-3 rounded-full">
                    <Phone className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl">Telefoon</h3>
                    <a href={`tel:${phoneTel}`} className="text-gray-700 hover:text-[#13498f]">
                      {phoneDisplay}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-[#13498f] p-3 rounded-full">
                    <Mail className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl">Email</h3>
                    <a href={`mailto:${email}`} className="text-gray-700 hover:text-[#13498f]">
                      {email}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-[#13498f] p-3 rounded-full">
                    <MapPin className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl">Werkgebied</h3>
                    <p className="text-gray-700">{werkgebied}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-[#13498f] p-3 rounded-full">
                    <Clock className="text-white" size={24} />
                  </div>
                  <div>
                    <h3 className="font-serif-display text-xl">Bereikbaarheid</h3>
                    <p className="text-gray-700 whitespace-pre-line">{bereik.replace(' | ', '\n')}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h3 className="font-serif-display text-2xl mb-4 text-[#13498f]">Volg Ons</h3>
              <div className="flex gap-4">
                <a
                  href={instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-br from-purple-500 to-pink-500 p-4 rounded-full text-white hover:scale-110 transition-transform duration-300"
                >
                  <Instagram size={28} />
                </a>
                <a 
                  href="https://tiktok.com/@cocktailmannetje1" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-black p-4 rounded-full text-white hover:scale-110 transition-transform duration-300"
                >
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Map Placeholder */}
          <div className="bg-gray-200 rounded-lg overflow-hidden shadow-summer h-96 flex items-center justify-center">
            <div className="text-center text-gray-600">
              <MapPin size={64} className="mx-auto mb-4 text-[#13498f]" />
              <p className="text-lg font-semibold">Werkzaam door heel Nederland</p>
            </div>
          </div>
        </div>
        </FadeInSection>
      </section>

      {/* CTA */}
      <section className="bg-[#F5E6D3] py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 text-[#13498f]">
            Klaar om te Boeken?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Vraag een vrijblijvende offerte aan en ontvang binnen 24 uur een reactie!
          </p>
          <a href="/offerte" className="btn-primary">
            Vraag Offerte Aan
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;